import { countRejectedCandidates } from './candidateStatus';

export const MONITOR_REASON_LABELS = {
  uploaded_today: 'Uploaded Today',
  status_updated_today: 'Status Updated Today',
  interview_today: 'Interview Today',
  pending_action: 'Pending Action',
  offer_stage: 'Offer Stage',
};

export const MONITOR_CARD_FILTERS = {
  total: 'total',
  highPriority: 'high_priority',
  interviewsToday: 'interviews_today',
  pendingAction: 'pending_action',
  offerStage: 'offer_stage',
};

export const MONITOR_FILTER_LABELS = {
  total: 'Total to Monitor',
  high_priority: 'High Priority',
  interviews_today: 'Interviews Today',
  pending_action: 'Pending Action',
  offer_stage: 'Offer Stage',
};

export const TL_REQUIREMENTS_MONITOR_PATH = '/team/requirements';

export function scopeTlRequirementRowForMonitor(row, candidateIds = []) {
  if (!row || !candidateIds?.length) return row;

  const allowed = new Set(candidateIds.map(String));
  const pick = (list) => (
    Array.isArray(list) ? list.filter((candidate) => allowed.has(String(candidate._id))) : list
  );

  const totalCandidatesDetails = pick(row.totalCandidatesDetails);
  const userActiveCandidatesDetails = pick(row.userActiveCandidatesDetails);
  const totalTeamCandidatesDetails = pick(row.totalTeamCandidatesDetails);
  const combinedTodayCandidates = pick(row.combinedTodayCandidates);

  return {
    ...row,
    totalCandidatesDetails,
    userActiveCandidatesDetails,
    totalTeamCandidatesDetails,
    combinedTodayCandidates,
    totalCandidateCount: totalCandidatesDetails?.length ?? 0,
    userCandidatesCount: userActiveCandidatesDetails?.length ?? 0,
    teamCandidatesCount: totalTeamCandidatesDetails?.length ?? 0,
    todayCandidateCount: combinedTodayCandidates?.length ?? 0,
    rejectedCandidatesCount: countRejectedCandidates(totalCandidatesDetails || []),
    _monitorCandidateIds: candidateIds,
  };
}

export function getMonitorBucket(data, monitorKey) {
  if (!data?.filterBuckets || !monitorKey) return null;
  return data.filterBuckets[monitorKey] || null;
}

export function itemMatchesMonitorCard(item, cardKey) {
  if (!item || !cardKey) return false;
  if (cardKey === MONITOR_CARD_FILTERS.total) return true;
  if (cardKey === MONITOR_CARD_FILTERS.highPriority) return item.priority === 'high';

  const reasons = Array.isArray(item.reasons) && item.reasons.length
    ? item.reasons
    : [item.reason];

  if (cardKey === MONITOR_CARD_FILTERS.interviewsToday) {
    return reasons.includes('interview_today');
  }
  if (cardKey === MONITOR_CARD_FILTERS.pendingAction) {
    return reasons.includes('pending_action');
  }
  if (cardKey === MONITOR_CARD_FILTERS.offerStage) {
    return reasons.includes('offer_stage');
  }
  return false;
}

export function filterMonitorItemsForCard(items = [], cardKey) {
  return (Array.isArray(items) ? items : []).filter((item) => itemMatchesMonitorCard(item, cardKey));
}
